import React from 'react'

import { useDispatch } from 'react-redux'

import { MyGoustoPage } from '@features/my-gousto-page'

import { actionTypes } from 'actions/actionTypes'
import actions from 'actions/user'

import { ReferAFriendContainer } from './ReferAFriendContainer'

export const MyGousto = () => {
  const dispatch = useDispatch()
  const dispatchCancelOrder = (orderId: string) => {
    dispatch({
      type: actionTypes.ORDER_CANCEL,
      orderId,
      restorable: false,
    })
  }
  const dispatchRefreshOrdersState = () => {
    dispatch(actions.userLoadOrdersForMyGousto(true))
  }

  return (
    <div data-testid="my-gousto">
      <MyGoustoPage
        dispatchCancelOrder={dispatchCancelOrder}
        dispatchRefreshOrdersState={dispatchRefreshOrdersState}
      />
      <ReferAFriendContainer />
    </div>
  )
}
